import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-backward",
  "use": "arrow-backward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-backward\"><path d=\"M5.5 5c-.002.003.5 0 .5.5s-.5.5-.5.5H1V1.5s0-.5.5-.5.502.498.5.5v2.893A6.996 6.996 0 018 1a7.002 7.002 0 010 14v-1a6 6 0 10-5.198-9H5.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol